import { createApp } from 'vue'
import App from './App.vue'
import Layui from '@layui/layui-vue'
import '@layui/layui-vue/lib/index.css'
import router from "@/assets/js/router";
import axios from "axios";
import useUtils from "@/assets/js/utils";
let {isLogin} = useUtils();
axios.interceptors.request.use(function (config) {
    config.baseURL = "https://zqc.spepi.cn/qt/";
    if (config.url.includes('login')){
        return config;
    }
    config.headers['access_token'] = localStorage.getItem("access_token");

    // if (config.method === 'post'){
    //
    // }
    // else if(config.method === 'get'){
    //
    // }
    config.timeout = 3500;
    return config;
}, function (error) {
    return Promise.reject(error);
});

axios.interceptors.response.use(function (response) {
    if(response.data.code == -2){
        isLogin.value = false;
        router.push({path: '/login'});
    }
    return response;
},function (error) {
    return Promise.reject(error);
});

const app = createApp(App)
app.directive('userNoSelect', (el) => {
    el.style.userSelect = 'none'
})

app.use(router).use(Layui).mount('#app')

